// @ts-check

const { default: registerElement } = await importMod("register-element");

/**
 * @typedef {InstanceType<typeof CustomElement>} CustomElement The exit-intent-dialog-layout element
 */

const CustomElement = registerElement("exit-intent-dialog-layout");

export default CustomElement;
